import { createAxiosInstance } from "@moodys/mdc-frontend.services.fetcher";
import { logger } from "@moodys/mdc-frontend.services.logger";

export const esgClient = createAxiosInstance({
  baseURL: "/esg-views/api",
});

export interface EsgDownloadsAuthorization {
  hasDocumentsContent: boolean;
}

export const fetchEsgDownloadsAuthorization = async (): Promise<
  EsgDownloadsAuthorization | undefined
> => {
  try {
    const response = await esgClient.get<EsgDownloadsAuthorization>(
      "/has-documents-content"
    );
    return response?.data;
  } catch (error) {
    logger.error({ error, message: "EsgDownloadsAuthorization fetch failed" });
    return;
  }
};
